export default __webpack_public_path__ + "assets/theia-1.c92a526c.png";